import {
  GET_ATTACHMENT,
  GET_ATTACHMENT_FAIL,
  GET_ATTACHMENT_SUCCESS,
  GET_GENERAL,
  GET_GENERAL_FAIL,
  GET_GENERAL_SUCCESS,
  GET_PROFILE_ATTACHMENT,
  GET_PROFILE_ATTACHMENT_FAIL,
  GET_PROFILE_ATTACHMENT_SUCCESS,
  GET_THUMBNAIL_ATTACHMENT_FAIL,
  GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  RESET_THUMBNAIL_ATTACHMENT_STATE,
  RESET_ATTACHMENT_STATE,
  RESET_GENERAL_STATE,
  GET_THUMBNAIL_ATTACHMENT,
  GET_VOUCHER_LIST,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAIL,
  GET_SERVICE_LIST,
  GET_SERVICE_LIST_SUCCESS,
  GET_SERVICE_LIST_FAIL,
} from "./actionTypes";

export const getGeneral = () => ({
  type: GET_GENERAL,
});

export const getGeneralSuccess = general => ({
  type: GET_GENERAL_SUCCESS,
  payload: general,
});

export const getGeneralFail = error => ({
  type: GET_GENERAL_FAIL,
  payload: error,
});

export const getAttachment = payload => ({
  type: GET_ATTACHMENT,
  payload: payload
});

export const getAttachmentSuccess = attachment => ({
  type: GET_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getAttachmentFail = error => ({
  type: GET_ATTACHMENT_FAIL,
  payload: error,
});

export const getProfileAttachment = payload => ({
  type: GET_PROFILE_ATTACHMENT,
  payload: payload
});

export const getProfileAttachmentSuccess = attachment => ({
  type: GET_PROFILE_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getProfileAttachmentFail = error => ({
  type: GET_PROFILE_ATTACHMENT_FAIL,
  payload: error,
});

export const getThumbnailAttachment = payload => ({
  type: GET_THUMBNAIL_ATTACHMENT,
  payload: payload
});

export const getThumbnailAttachmentSuccess = attachment => ({
  type: GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getThumbnailAttachmentFail = error => ({
  type: GET_THUMBNAIL_ATTACHMENT_FAIL,
  payload: error,
});

export const getVoucherList = payload => ({
  type: GET_VOUCHER_LIST,
  payload: payload
});

export const getVoucherListSuccess = payload => ({
  type: GET_VOUCHER_LIST_SUCCESS,
  payload: payload,
});

export const getVoucherListFail = error => ({
  type: GET_VOUCHER_LIST_FAIL,
  payload: error,
});

export const getServiceList = ({ id }) => ({
  type: GET_SERVICE_LIST,
  payload: id
});

export const getServiceListSuccess = payload => ({
  type: GET_SERVICE_LIST_SUCCESS,
  payload: payload,
});

export const getServiceListFail = error => ({
  type: GET_SERVICE_LIST_FAIL,
  payload: error,
});

//reset
export const resetGeneralState = () => {
  return {
    type: RESET_GENERAL_STATE,
  }
}
export const resetAttachmentState = () => {
  return {
    type: RESET_ATTACHMENT_STATE,
  }
}


export const resetThumbnailAttachmentState = () => {
  return {
    type: RESET_THUMBNAIL_ATTACHMENT_STATE,
  }
}

